import React, { useState } from "react";
import { Loader2, KeyRound } from "lucide-react";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

// Fresh-OTP confirmation, used only for changing payout details or the phone number.
export const StepUpDialog = ({ open, purpose, title, onClose, onVerified }) => {
  const [otp, setOtp] = useState("");
  const [devOtp, setDevOtp] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  const send = async () => {
    setBusy(true);
    try { const r = await api.post("/auth/step-up/request"); setDevOtp(r.data.dev_otp || ""); setSent(true); }
    catch (e) { toast.error(apiError(e)); }
    setBusy(false);
  };
  const verify = async () => {
    setBusy(true);
    try {
      const r = await api.post("/auth/step-up/verify", { otp, purpose });
      setOtp(""); setSent(false);
      await onVerified(r.data.step_up_token);
    } catch (e) { toast.error(apiError(e, "Incorrect code")); }
    setBusy(false);
  };
  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) { setSent(false); setOtp(""); onClose(); } }}>
      <DialogContent data-testid="step-up-dialog">
        <DialogHeader>
          <DialogTitle>{title || "Confirm it's you"}</DialogTitle>
          <DialogDescription>For your security we send a one-time code to your registered phone before changing where money goes or your phone number.</DialogDescription>
        </DialogHeader>
        {!sent ? (
          <Button data-testid="step-up-send-btn" onClick={send} disabled={busy} className="rounded-full">{busy ? <Loader2 className="w-4 h-4 animate-spin"/> : "Send code"}</Button>
        ) : (
          <div className="space-y-2">
            {devOtp && <div className="text-xs bg-amber-50 border border-amber-200 text-amber-800 rounded-lg px-3 py-2"><KeyRound className="inline w-3 h-3 mr-1"/> Dev OTP: <span className="font-mono font-bold">{devOtp}</span></div>}
            <Input data-testid="step-up-otp-input" inputMode="numeric" maxLength={6} value={otp} onChange={(e) => setOtp(e.target.value.replace(/\D/g, ""))} placeholder="6-digit code"/>
            <Button data-testid="step-up-verify-btn" onClick={verify} disabled={busy || otp.length !== 6} className="w-full rounded-full">{busy ? <Loader2 className="w-4 h-4 animate-spin"/> : "Confirm"}</Button>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default StepUpDialog;
